module.exports = {
  siteTitle: 'fireadmin-docs',
  siteDescription: 'Fireadmin documentation.',
  authorName: 'Prescott Prue',
  authorAvatar: '/images/avatar.png',
  authorDescription:
    'Mechanical/Aerospace engineer turned fullstack javascript developer. Author of react-redux-firebase, redux-firestore and other tools.',
  siteUrl: 'https://docs.fireadmin.io',
  // Prefixes all links
  pathPrefix: '/docs', // Note: it must *not* have a trailing slash.
  siteCover: '/images/cover.jpg',
  googleAnalyticsId: 'G-Y3XG94BTJX',
  background_color: '#ffffff',
  theme_color: '#ef6c00',
  icon: 'src/assets/FireadminLogo.png'
}
